module.exports = __webpack_public_path__ + "media/app/images/github-gist-f60f261b0d3ccd373ea12f1aa3551c5a.png";